import axios from 'axios';
import { GOOGLE_PLACE_API_KEY } from './config';
import LogoIcon from '../src/assets/img/logo_noty.png';


export const SIDEBAR_POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const SIDEBAR_BEHAVIOR = {
  STICKY: 'sticky',
  FIXED: 'fixed',
  COMPACT: 'compact',
};

export const LAYOUT = {
  FLUID: 'fluid',
  BOXED: 'boxed',
};

export const THEME = {
  DEFAULT: 'default',
  COLORED: 'colored',
  DARK: 'dark',
  LIGHT: 'light',
};

export const THEME_PALETTE_LIGHT = {
  primary: '#3B82EC',
  'primary-dark': '#1659c7',
  'primary-light': '#84aef2',
  secondary: '#495057',
  success: '#4BBF73',
  info: '#1F9BCF',
  warning: '#f0ad4e',
  danger: '#d9534f',
  white: '#fff',
  'gray-100': '#f4f7f9',
  'gray-200': '#e2e8ee',
  'gray-300': '#dee6ed',
  'gray-400': '#ced4da',
  'gray-500': '#adb5bd',
  'gray-600': '#6c757d',
  'gray-700': '#495057',
  'gray-800': '#020202',
  'gray-900': '#212529',
  black: '#000',
};

export const THEME_PALETTE_DARK = {
  ...THEME_PALETTE_LIGHT,
  'primary-dark': '#84aef2',
  'primary-light': '#1659c7',
  white: '#293042',
  'gray-100': '#3e4555',
  'gray-200': '#545968',
  'gray-300': '#696e7b',
  'gray-400': '#7f838e',
  'gray-500': '#9498a1',
  'gray-600': '#a9acb3',
  'gray-700': '#bfc1c6',
  'gray-800': '#d4d6d9',
  'gray-900': '#eaeaec',
  black: '#fff',
};

export const getScoreText = score => {
  let text = 'Bad';
  if (score >= 300 && score <= 560) {
    text = 'Poor';
  } else if (score >= 561 && score <= 629) {
    text = 'Bad';
  } else if (score >= 630 && score <= 689) {
    text = 'Fair';
  } else if (score >= 690 && score <= 719) {
    text = 'Good';
  } else if (score >= 720 && score <= 800) {
    text = 'Great';
  } else if (score >= 801 && score <= 850) {
    text = 'Excellent';
  }

  return text;
};

export const calculateCreditLimitSuggestAmount = limit => {
  const mulitple = 500;
  const division = limit / mulitple;
  return Number.isInteger(division) ? (Math.floor(division) + 1) * mulitple : (Math.floor(division) + 2) * mulitple;
};

export const calculateReduceBalance = (limit, payment) => {
  return Math.floor(limit * payment);
};

// export const calculateReduceBalance = (limit, payment) => {
//   // const mulitple = 150;
//   // const division =  mulitple / limit; toFixed
//   let num = limit * payment;
//   return Math.round(num);
// };

export const loadScript = url => {
  let script = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
      }
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export const handleScriptLoad = async (query, callback) => {
  let placeAPi = new window.google.maps.places.AutocompleteService();
  const { predictions } = await placeAPi.getPlacePredictions({ input: query });
  if (!predictions.length) return null;
  const prediction = predictions[0];
  if (!window.placeService) {
    window.placeService = new window.google.maps.places.PlacesService(document.createElement('div'));
  }
  // const resp = await fetch(`https://maps.googleapis.com/maps/api/place/details/json?place_id=${prediction.place_id}&key=${GOOGLE_PLACE_API_KEY}`)
  window.placeService.getDetails(
    {
      placeId: prediction.place_id,
    },
    place => callback(place)
  );
};


export const showNotification = (title,message) => {
  var options = {
    body: 'Notification Body',
    icon: 'https://app.dispute.ly/assets/images/favicon-32x32.png',
    dir: 'ltr',
  };
  new Notification('Hello World', options);
}

export const generateRandomString = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let randomString = '';
  for (let i = 0; i < 8; i++) {
    randomString += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return btoa(randomString);
}

export function compareUserInput(userInput, generatedString) {
  const decodedString = atob(generatedString);
  return userInput === decodedString;
}

export const getInitials = name => {
  if (!name) return '??';
  const splitName = name.split(' ');
  if (splitName.length < 2) return splitName[0].charAt(0).toUpperCase();
  return `${splitName[0].charAt(0).toUpperCase()}${splitName[splitName.length - 1].charAt(0).toUpperCase()}`;
};

export const getScoreColor = {
  'NO CREDIT SCORE': '',
  Poor: 'danger',
  Bad: 'danger',
  Fair: 'orange',
  Good: 'warning',
  Great: 'teal',
  Excellent: 'success',
};